<template>
  <div class="createmenu">
    <v-container>
      <v-card width="70%" class="mx-auto mt-15">
        <v-form class="mx-5 my-auto">
          <v-radio-group row v-model="timer" label="Timer per person, per turn">
            <v-radio label="30s" value="30" class="ml-10"></v-radio>
            <v-radio label="60s" value="60"></v-radio>
            <v-radio label="90s" value="90"></v-radio>
          </v-radio-group>
          <v-switch
            v-model="passing"
            label="Allow Passing"
            value="true"
          ></v-switch>
        </v-form>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn width="100%" @click="create">Create!</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "CreateMenu",
  components: {},
  props: {
    playerName: String,
  },
  methods: {
    create() {
      this.$router.push({
        name: "Creating",
        params: {
          timer: this.timer,
          passing: this.passing,
          playerName: this.playerName,
        },
      });
    },
  },
  data() {
    return {
      timer: "60",
      passing: "true",
    };
  },
};
</script>
